import { BookingTypesDbModel } from '@db-models/booking-types.model';
import { ConferenceStatusType } from '@db-models/conference-db.model';
import { WorkerAttributeDbModel } from '@db-models/worker-db.model';

export class EmployeeFormModel {
  uuid: string;
  id: number;
  prename: string;
  lastname: string;
  username: string;
  email: string;
  password: string;
  password_repeat: string;
  job_title: string;
  conference_url: string;
  hubspot_owner_id?: string | null;
  store_id: number;
  bookable: boolean | number;
  is_directly_bookable: boolean;
  show_in_pro_calendar: boolean | number;
  is_reseller_admin: boolean | number;
  is_round_robin_enabled: boolean | number;
  appointmentServices?: number[];
  is_resource: boolean | number;
  bookingType: BookingTypesDbModel;
  booking_label: string;
  description: string;
  booking_type_id: number;
  booking_type_uuid: string;
  booking_type: BookingTypesDbModel;
  lang_identifier: string;
  timezone: string;
  ics_file_employee_method: 'PUBLISH' | 'REQUEST' | '' | null;
  mobile: string;
  calendar_color: string;
  role_ids: number[];
  is_multi_language: number;
  is_location_dependent: boolean | string;
  hide_past_appointments: number;
  // Parsed id list while the form is live, JSON text once serialised for the API.
  block_resource_dependencies: string | number[] | null;
  show_availabilities_in_calendar: number;
  appointment_booking_limit: number;
  _translations: {
    [key: string]: EmployeeMultiTranslationForm
  };
  formControl_default: EmployeeMultiTranslationForm;
  conference_filter_state?: ConferenceStatusType;
  attributes: { [key: string]: boolean | string } | WorkerAttributeDbModel[];
}

export class ServiceWorkerModel {
  worker_id: number;
  service_ids: number[];
  /**
   * Which store this service set applies to. Omitted for single-store partners and
   * for resources without the addon, where the backend keeps its legacy
   * replace-everything behaviour. Sending it for a worker with several stores is
   * mandatory — without it the backend refuses the write rather than guess which
   * store the admin meant.
   */
  store_id?: number;
}

export class EmployeeMultiTranslationForm {
  job_title?: string;
  booking_label?: string;
  description?: string;
  full_name?: string;
  resource_name?: string;
}
